// extracted by mini-css-extract-plugin
module.exports = {"appbar":"Header_appbar__BDOJC","title":"Header_title__GPS8b","logo":"Header_logo__K13hK"};